const getTimezone = function() {
  try {
    const dateString = `${new Date()}`;
    let tzAbbr = (
      // Works for the majority of modern browsers
      dateString.match(/\(([^\)]+)\)$/) ||
      // IE outputs date strings in a different format:
      dateString.match(/([A-Z]+) [\d]{4}$/)
    );

    if (!tzAbbr[1]) return null;

    if (tzAbbr) {
      if (!/[A-Z]/.test(tzAbbr[1])) return null;
      // Old Firefox uses the long timezone name (e.g., "Central
      // Daylight Time" instead of "CDT")
      tzAbbr = tzAbbr[1].match(/[A-Z]/g).join('');
    }
    return tzAbbr;
  } catch (e) {
    return null;
  }
};

export default getTimezone;
